/**
 * useAccountChoiceState — les gestes de « Ajouter un compte » (`account-choice`), l'arrivée du « + »
 * de « Qui utilise Masteur ? ».
 *
 * Port de `auth/AccountChoiceScreen.js` (legacy), geste par geste :
 *  - « Me connecter » pousse `login`, comme « JE ME CONNECTE » ;
 *  - « Ajouter un élève » ouvre le formulaire du site (`SIGNUP_URL`, l'adresse du legacy) ; la sortie
 *    passe par `openExternalUrl`, le geste commun des écrans portés : un onglet sur le web, le
 *    navigateur intégré ailleurs (le legacy ouvrait le navigateur du téléphone) ;
 *  - « Devenir tuteur » pousse `register`, comme « DEVENIR TUTEUR » ;
 *  - le retour revient en arrière, sinon remplace par `family-account-selection`, comme la flèche du
 *    legacy.
 */
import { useNavigation } from "@react-navigation/native"

import { openExternalUrl } from "../../../hooks/openExternalUrl"
import { useBackOr } from "../../../hooks/useBackOr"

const SIGNUP_URL = "https://fr.masteur.com/?show_form=1"

export type AccountChoiceState = {
    onSignIn: () => void
    onAddStudent: () => void
    onBecomeTutor: () => void
    onBack: () => void
}

export function useAccountChoiceState(): AccountChoiceState {
    const navigation = useNavigation<{ push: (name: string) => void }>()
    const onBack = useBackOr("family-account-selection")

    return {
        onSignIn: () => navigation.push("login"),
        onAddStudent: () => openExternalUrl(SIGNUP_URL),
        onBecomeTutor: () => navigation.push("register"),
        onBack,
    }
}
